import React, { useCallback, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import PageNotFound from '@assets/Images/stub/page-not-found-stub.svg';
import { AgendaRoutePathEnum } from '@setup/router/routes/agenda/agenda-route-path-enum';
import { AuthRoutesPathEnum } from '@setup/router/routes/auth/authRoutesPath.enum';
import { ChecklistsRoutesPathEnum } from '@setup/router/routes/checklists/checklistsRoutesPath.enum';
import { FinanceRoutesPathEnum } from '@setup/router/routes/finance/financeRoutesPath.enum';
import { ProfileRoutesPathEnum } from '@setup/router/routes/profile/profileRoutesPath.enum';
import { RoadmapRoutesPathEnum } from '@setup/router/routes/roadmap/RoadmapRoutesPath.enum';
import { Stub } from '@shared/ui-kit';

import { ErrorNotFoundContainer } from './ErrorNotFound.style';

const ErrorNotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);

  const checkAndRedirect = useCallback(() => {
    const currentPath = window.location.pathname;
    if ([AuthRoutesPathEnum.signUp, AuthRoutesPathEnum.signIn].includes(currentPath as AuthRoutesPathEnum)) {
      navigate(AuthRoutesPathEnum.auth, { replace: true });
    }
    if (
      [AuthRoutesPathEnum.signUpPhone, AuthRoutesPathEnum.signInPhone].includes(
        currentPath as AuthRoutesPathEnum,
      )
    ) {
      navigate(AuthRoutesPathEnum.auth_phone, { replace: true });
    }
    if (
      [AuthRoutesPathEnum.signInEmail, AuthRoutesPathEnum.signUpEmail].includes(
        currentPath as AuthRoutesPathEnum,
      )
    ) {
      navigate(AuthRoutesPathEnum.auth_email, { replace: true });
    }

    if (currentPath === '/todo') {
      navigate(ChecklistsRoutesPathEnum.checklists, { replace: true });
    }
    if (currentPath === '/backlog') {
      navigate(RoadmapRoutesPathEnum.tasks, { replace: true });
    }
    if (currentPath === '/profile') {
      navigate(ProfileRoutesPathEnum.base, { replace: true });
    }
    if (currentPath === '/planner') {
      navigate(AgendaRoutePathEnum.agenda, { replace: true });
    }
    if (currentPath === '/journal') {
      navigate(AgendaRoutePathEnum.agenda, { replace: true });
    }
    if (currentPath === '/calendar') {
      navigate(AgendaRoutePathEnum.agenda, { replace: true });
    }
    if (currentPath === '/finance/payment-history') {
      navigate(`${FinanceRoutesPathEnum.finance}/${FinanceRoutesPathEnum.paymentHistory}`, { replace: true });
    }
    if (currentPath.includes('/accounting')) {
      navigate(FinanceRoutesPathEnum.finance, { replace: true });
    }
    setIsChecked(true);
  }, [navigate]);

  const handleDefaultRedirect = () => {
    navigate('/', { replace: true });
  };

  useEffect(() => {
    checkAndRedirect();
  }, [checkAndRedirect]);

  if (!isChecked) {
    return null;
  }

  return (
    <ErrorNotFoundContainer>
      <Stub
        config={{
          img: PageNotFound,
          title: t('notFoundError.title'),
          description: t('notFoundError.description'),
        }}
        buttonProps={{
          label: t('notFoundError.link'),
          onClick: handleDefaultRedirect,
        }}
      />
    </ErrorNotFoundContainer>
  );
};

export default ErrorNotFound;
